import {
  RectangleHorizontalIcon,
  RectangleVerticalIcon,
  SquareIcon,
} from 'lucide-react'

import type { MediaFormatType } from '@/prisma/generated/zod/inputTypeSchemas/MediaFormatSchema'
import { SegmentedControl, Tooltip } from '~/ui'

interface AspectRatioInputProps {
  value: MediaFormatType
  onChange: (value: MediaFormatType) => void
  className?: string
}

const AspectRatioInput = ({
  className,
  value,
  onChange,
  ...props
}: AspectRatioInputProps) => {
  return (
    <Tooltip.Group>
      <SegmentedControl variant="over-media" className={className} {...props}>
        {['portrait', 'square', 'landscape'].map((ratio) => (
          <Tooltip key={ratio} delayIn={900}>
            <Tooltip.Trigger>
              <SegmentedControl.Item
                value={ratio}
                checked={ratio === value}
                onChange={() => onChange(ratio as MediaFormatType)}
              >
                {ratio === 'portrait' && (
                  <RectangleVerticalIcon className="size-4" />
                )}
                {ratio === 'square' && <SquareIcon className="size-4" />}
                {ratio === 'landscape' && (
                  <RectangleHorizontalIcon className="size-4" />
                )}
              </SegmentedControl.Item>
            </Tooltip.Trigger>
            <Tooltip.Content className="tabular-nums">
              {ratio === 'portrait' && '3:4'}
              {ratio === 'square' && '1:1'}
              {ratio === 'landscape' && '4:3'}
            </Tooltip.Content>
          </Tooltip>
        ))}
      </SegmentedControl>
    </Tooltip.Group>
  )
}

export { AspectRatioInput }
